<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>

          <CCardBody>

            <BTabs :active-tab.sync="active_tab" >
              <CTab  v-if="has_permission('ProductCoding') && get_access('country')" :title="$t('country')">
                <Country/>
              </CTab>
              <CTab v-if="has_permission('DeliveryCosts')  && get_access('county')" :title="$t('components.province')">
                <Province/>
              </CTab>
              <CTab v-if="has_permission('DeliveryCosts')" :title="$t('components.city')">
                <City/>
              </CTab>
              <CTab v-if="has_permission('DeliveryCosts')" :title="$t('districts')">
                <District/>
              </CTab>
              <CTab v-if="has_permission('DeliveryCosts')" :title="$t('areas')">
                <Areas/>
              </CTab>


              <CTab v-if="has_permission('DeliveryCosts')" :title="$t('routes')">
                <InsertRoutes/>
              </CTab>


            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import BTabs from "../../tabs/BTabs";
import SaleMethods from "@/views/panel/accounting/SaleMethods";
import InsertWheicle from "@/views/panel/delivery/InsertWheicle";
import InsertRoutes from "@/views/panel/delivery/InsertRoutes";
import DirectSellSupplier from "./DirectSellSupplier";
var items = [];
import Areas from "../base/Areas";
import District from "../base/District";
import Country from "./Country";
import Province from "../base/Province";
import City from "../base/Cities";
export default {
  name: 'SaleSettingsComponent',
  components: {
    BTabs,
    Areas,
    Country,
    District,
    Province,
    City,
    InsertWheicle,
    InsertRoutes,
    DirectSellSupplier
  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      active_tab:parseInt(localStorage.getItem("sale_setting_active_tab",0)),

    }
  }, mounted() {
    this.$root.root_validate_errors = [];


  }, watch: {

    'active_tab': function () {
      localStorage.setItem("sale_setting_active_tab",this.active_tab)
    }
  },
  methods: {

  }
}

</script>
